import { render, staticRenderFns } from "./purchaseMsgPush.vue?vue&type=template&id=30efd9dc&scoped=true&"
import script from "./purchaseMsgPush.vue?vue&type=script&lang=js&"
export * from "./purchaseMsgPush.vue?vue&type=script&lang=js&"
import style0 from "./purchaseMsgPush.vue?vue&type=style&index=0&id=30efd9dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30efd9dc",
  null
  
)

component.options.__file = "purchaseMsgPush.vue"
export default component.exports